<template>
  <div>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="batchLoading"
    >
      <b-card>
        <b-table
          responsive
          :fields="columns"
          :items="cardsBatch"
          primary-key="id"
          show-empty-a-f
          empty-text="No matching cards found"
        >
          <template #cell(details)="data">
            <p>No. of cards: {{ data.item.details.number_of_cards }}</p>
            <p>Amount per card: {{ data.item.details.amount_per_card }}</p>
          </template>
          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
            >

              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <div
                :id="`batch-downloaded-${data.item.id}`"
              >
                <b-dropdown-item
                  :disabled="data.item.downloaded"
                  @click="downloadBatch(data.item.id)"
                >
                  <feather-icon icon="DownloadIcon" />
                  <span class="align-middle ml-50">Download</span>

                </b-dropdown-item>
              </div>
              <b-tooltip
                v-if="data.item.downloaded"
                :target="`batch-downloaded-${data.item.id}`"
                title="Already downloaded"
                triggers="hover"
              />
            </b-dropdown>
          </template>
        </b-table>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BTable, BOverlay, BDropdown, BDropdownItem, BTooltip,
} from 'bootstrap-vue'
import store from '../store'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import useBatchList from '../hooks/useBatchList'

export default {
  components: {
    BCard,
    BTable,
    BOverlay,
    BDropdown,
    BDropdownItem,
    BTooltip,
  },
  setup(_, ctx) {
    useRegisterStoreModule('cardsBatch', store)
    return {
      ...useBatchList(ctx),
    }
  },
}
</script>

<style>

</style>
